module.exports = __webpack_public_path__ + "static/img/icoImg.95372c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/icoImg.png
// module id = c/bC
// module chunks = 23